import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrCreateClientInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-user-plus', title: 'ITR Create Client', subtitle: 'Register a new ITR client (PAN-based username + password)' }}
        fields={[
            { name: 'username', label: 'Username (PAN)', icon: 'pi-id-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              regex: /^[A-Z]{5}\d{4}[A-Z]$/, regexError: 'Invalid PAN format' },
            { name: 'password', label: 'Password', icon: 'pi-lock', placeholder: 'Enter password', maxLength: 64, htmlType: 'password' },
        ]}
        endpoint={{
            path: '/surepass/itr/create-client',
            bodyMapper: (v, sid) => ({ username: v.username, password: v.password, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-create-client"
        submitLabel="Create Client"
        successSummary="ITR client created"
        errorSummary="ITR client creation failed"
        confirmHeader="Confirm ITR client creation"
        confirmAcceptLabel="Yes, create"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Client', icon: 'pi-user-plus' }}
    />
);

export default ItrCreateClientInputComponent;
